const positiveNumberRegEx = /^\d*[0-9]\d*$/;
const alphabeticalRegEx = /^[a-zA-Z]+$/;

export const validatePositiveNumber = input => positiveNumberRegEx.test(input);
export const validateString = input => alphabeticalRegEx.test(input);
